import { Component, computed, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControlStatus, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput, MatSuffix } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { FidelityAvailablePages } from 'app/shared/components/fidelity-base-page/fidelity-base-page.types';
import { FuseValidators } from '../../../../../@fuse/validators';
import { FidelityBasePageComponent } from '../../../../shared/components/fidelity-base-page/fidelity-base-page.component';
import { FidelityOverlayPageWrapperComponent } from '../../../../shared/components/fidelity-overlay-page-wrapper/fidelity-overlay-page-wrapper.component';
import { SafePipe } from '../../../../shared/pipes/safe.pipe';
import { CustomAuthValidators } from '../../../../shared/validators/auth.validators';
import { FidelityPersonalDataService } from '../../personal-data/personal-data.service';
import { UpdatePasswordDto } from '../../personal-data/personal-data.types';

@Component({
    selector: 'security',
    imports: [
        FidelityOverlayPageWrapperComponent,
        TranslocoDirective,
        MatButton,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatInput,
        ReactiveFormsModule,
        MatProgressSpinner,
        MatLabel,
        MatSuffix,
        SafePipe,
    ],
    templateUrl: './security-page.component.html',
    styleUrl: './security-page.component.scss',
})
export class SecurityPageComponent extends FidelityBasePageComponent {
    public availablePages: FidelityAvailablePages = {};
    passwordForm: FormGroup;
    passwordFormStatus: Signal<FormControlStatus | undefined>;
    protected disableCrudActions: Signal<boolean> = this.personalDataService.disableCrudActions;

    disableSave = computed<boolean>(() => {
        this.passwordFormStatus();
        return this.passwordForm.invalid || this.disableCrudActions();
    });

    constructor(
        private fb: FormBuilder,
        private personalDataService: FidelityPersonalDataService
    ) {
        super();

        this.passwordForm = this.fb.group(
            {
                currentPassword: ['', Validators.required],
                newPassword: ['', [Validators.required, CustomAuthValidators.passwordStrengthValidator()]],
                confirmNewPassword: ['', Validators.required],
            },
            {
                validators: FuseValidators.mustMatch('newPassword', 'confirmNewPassword'),
            }
        );
        this.passwordFormStatus = toSignal(this.passwordForm.statusChanges);
    }

    saveChanges() {
        const dto: UpdatePasswordDto = this.passwordForm.value;
        this.personalDataService
            .updatePassword(dto)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.notifyResult(
                    this.translocoService.translate('fidelity-app.account.security.notification-caption')
                );
                this.navBack();
            });
    }
}
